<template>
  <div class="home general" v-on:scroll="onScroll">
    <h1 class="section-title">
      Canciones que no gustan
    </h1>

    <va-data-table
      class="ekitable"
      :items="dislikes"
      :columns="columns"
      no-data-html="<div class='no-data'>Sin canciones que no gusten</div>"
      :sticky-header="true"
      :loading="false"
      loading-text=""
    >
      <template #headerPrepend>
        <tr>
          <th colspan="4">
            <va-input
              class="search-bar"
              title="Buscar canción que no gusta"
              v-title
              placeholder="Número, canción o usuario"
              v-on:keyup.enter="onEnter"
              v-on:focusout="onEnter"
              v-model="search"
            >
              <template #prependInner>
                <font-awesome-icon :icon="['fa-solid', 'search']" />
              </template>
            </va-input>
          </th>
        </tr>
      </template>
      <template #cell(user)="{ rowData }">
        <div>{{ rowData.userName || 'Usuario' }}</div>
        <div v-if="rowData.userEmail">{{ rowData.userEmail }}</div>
      </template>
      <template #cell(dislikedAt)="{ rowData }">
        {{ formatDate(rowData.dislikedAt) }}
      </template>
    </va-data-table>
  </div>
</template>

<script>
import requester from "@/services/requester";

export default {
  data() {
    return {
      page: 1,
      isLoading: false,
      dislikes: [],
      continueLoading: true,
      search: "",
      columns: [
        { key: "num", sortable: false, label: "Número" },
        { key: "title", sortable: false, label: "Canción" },
        { key: "user", sortable: false, label: "Usuario" },
        { key: "dislikedAt", sortable: false, label: "Fecha del no me gusta" },
      ],
    };
  },
  methods: {
    formatDate(value) {
      if (!value) {
        return "";
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return "";
      }
      return date.toLocaleString("es-EC", { timeZone: "America/Guayaquil" });
    },
    onEnter() {
      this.page = 1;
      this.dislikes = [];
      this.continueLoading = true;
      this.getFromApi();
    },
    async getFromApi(isScroll = false) {
      this.isLoading = true;
      const data = await requester.Get(
        `/disliked-songs/${this.page}/?search=${encodeURIComponent(this.search)}`,
        true
      );
      if (data.status === 200) {
        const pageItems = data.data.dislikes || [];
        if (!isScroll) {
          this.dislikes = pageItems;
        } else {
          this.dislikes = this.dislikes.concat(pageItems);
        }
        if (pageItems.length > 0) {
          this.page++;
          this.continueLoading = true;
        } else {
          this.continueLoading = false;
        }
      }
      this.isLoading = false;
    },
    onScroll(event) {
      if (!this.continueLoading || this.isLoading) {
        return;
      }
      const { target } = event;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight) {
        this.getFromApi(true);
      }
    },
  },
  created() {
    this.onEnter();
  },
};
</script>
